var _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAppsMobileActive = function SvgIcAppsMobileActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-apps-mobile-active_svg__ic-apps-mobile-active",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 2,
    width: 34,
    height: 44,
    rx: 4,
    fill: "#ffe6d6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 28,
    height: 33,
    rx: 2,
    fill: "#ffc39c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 42,
    r: 2,
    fill: "#ffc39c"
  })));
};
export default SvgIcAppsMobileActive;